//import { STAGE_CONFIG } from "./config";

export const configScript = document.createElement('script')
configScript.textContent = `
  window.FontAwesomeConfig = {
    autoReplaceSvg: 'nest'
  };
`
document.head.appendChild(configScript)

// currently always points to the same bucket DEV
// const getFontAwesomeUrl = () => {
//     if (STAGE_CONFIG.stage === "dev") {
//         return "https://assets.atlas-apps-dev.mit.edu/font-awesome/css/all.css";
//     }
//
//     if (STAGE_CONFIG.stage === "test") {
//         return "https://assets.atlas-apps-test.mit.edu/font-awesome/css/all.css";
//     }
//
//     return "https://assets.atlas-apps.mit.edu/font-awesome/css/all.css";
// };

const link = document.createElement('link')
link.rel = 'stylesheet'
link.href = 'https://assets.atlas-apps-dev.mit.edu/font-awesome/css/all.css'
document.head.appendChild(link)
